<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Filters</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="page-pad">

    <div class="field">
      <label class="field-label">Status</label>
      <ion-segment mode="ios" [(ngModel)]="statusSegment">
        <ion-segment-button value="all">All</ion-segment-button>
        <ion-segment-button value="completed">Completed</ion-segment-button>
        <ion-segment-button value="pending">Pending</ion-segment-button>
      </ion-segment>
    </div>

    <div class="field">
      <label class="field-label">From</label>
      <div class="date-row">
        <div class="date-trigger filter-input" id="orders-filter-from-trigger">
          <span [class.placeholder]="!startDate">
            {{ startDate ? (startDate | date : 'dd MMM yyyy') : 'From' }}
          </span>
          <ion-icon name="calendar-outline"></ion-icon>
        </div>
        @if (startDate) {
        <ion-icon class="date-clear" name="close-circle" (click)="clearStartDate()"></ion-icon>
        }
      </div>
      <ion-popover trigger="orders-filter-from-trigger" [keepContentsMounted]="true" side="bottom" alignment="start">
        <ng-template>
          <ion-datetime
            presentation="date"
            [value]="startDate || null"
            [max]="endDate || todayIso"
            [showDefaultButtons]="true"
            (ionChange)="onStartDate($event)">
          </ion-datetime>
        </ng-template>
      </ion-popover>
    </div>

    <div class="field">
      <label class="field-label">To</label>
      <div class="date-row">
        <div class="date-trigger filter-input" id="orders-filter-to-trigger">
          <span [class.placeholder]="!endDate">
            {{ endDate ? (endDate | date : 'dd MMM yyyy') : 'To' }}
          </span>
          <ion-icon name="calendar-outline"></ion-icon>
        </div>
        @if (endDate) {
        <ion-icon class="date-clear" name="close-circle" (click)="clearEndDate()"></ion-icon>
        }
      </div>
      <ion-popover trigger="orders-filter-to-trigger" [keepContentsMounted]="true" side="bottom" alignment="start">
        <ng-template>
          <ion-datetime
            presentation="date"
            [value]="endDate || null"
            [min]="startDate || null"
            [max]="todayIso"
            [showDefaultButtons]="true"
            (ionChange)="onEndDate($event)">
          </ion-datetime>
        </ng-template>
      </ion-popover>
    </div>

    <label class="conflict-toggle">
      <input type="checkbox" [(ngModel)]="conflictOnly" />
      <span>Conflicts only</span>
    </label>

    <label class="conflict-toggle">
      <input type="checkbox" [(ngModel)]="razorpayOnly" />
      <span>Razorpay subscriptions only</span>
    </label>

    <div class="actions">
      <super-button type="fill" background="dark" color="light" [action]="apply">
        Apply filters
      </super-button>
      @if (hasActiveFilters) {
      <button type="button" class="clear-link" (click)="clearAll()">
        Clear filters
      </button>
      }
    </div>

  </div>
</ion-content>
